var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.chipLink
    ? _c(
        "RouterLink",
        { attrs: { to: _vm.chipLink } },
        [
          _c("Chip", {
            attrs: {
              variant: _vm.variant,
              chipLink: _vm.chipLink,
              chipData: _vm.chipData,
              chipText: _vm.chipText,
              avatar: _vm.avatar,
              wrapChip: _vm.wrapChip,
              chipClass: _vm.chipClassParent,
            },
          }),
        ],
        1
      )
    : _c("Chip", {
        attrs: {
          variant: _vm.variant,
          chipLink: _vm.chipLink,
          chipData: _vm.chipData,
          chipText: _vm.chipText,
          avatar: _vm.avatar,
          wrapChip: _vm.wrapChip,
          chipClass: _vm.chipClassParent,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }